import { GroqSuggestion } from "./groqService";
import { dummyChannelVideos, dummyTrendingVideos, dummyGroqSuggestion } from "./dummyData";

export interface YouTubeData {
  title: string;
  keywords: string[];
  thumbnail: string;
}

export const fetchChannelTags1 = async (
  url: string,
  apiKey: string
): Promise<YouTubeData> => {
  // 1. Simple Regex to get handle or ID from URL
  const match = url.match(/(?:@|channel\/|user\/)([a-zA-Z0-9_-]+)/);
  const identifier = match ? match[1] : url;

  // 2. Call YouTube API (search for channel)
  const response = await fetch(
    `https://www.googleapis.com/youtube/v3/search?part=snippet&type=channel&q=${identifier}&key=${apiKey}`
  );
  const data = await response.json();
  const channelId = data.items[0]?.id?.channelId;

  // 3. Get Channel Details (Keywords)
  const detailRes = await fetch(
    `https://www.googleapis.com/youtube/v3/channels?part=brandingSettings,snippet&id=${channelId}&key=${apiKey}`
  );
  const detailData = await detailRes.json();

  const channel = detailData.items[0];
  const keywordsString = channel.brandingSettings?.channel?.keywords || "";

  return {
    title: channel.snippet.title,
    thumbnail: channel.snippet.thumbnails.default.url,
    keywords: keywordsString
      .split(" ")
      .map((k: string) => k.replace(/"/g, ""))
      .filter(Boolean),
  };
};

export interface YouTubeVideo {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  publishedAt: string;
  viewCount?: string;
}

export const fetchChannelVideos = async (
  apiKey: string,
  channelId: string,
  maxResults: number = 20
): Promise<YouTubeVideo[]> => {
  try {
    const response = await fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&order=date&type=video&maxResults=${maxResults}&key=${apiKey}`
    );
    const data = await response.json();
    
    if (!data.items || !apiKey || apiKey === "YOUR_GOOGLE_API_KEY") return dummyChannelVideos;

    return data.items.map((item: any) => ({
      id: item.id.videoId,
      title: item.snippet.title,
      description: item.snippet.description,
      thumbnail: item.snippet.thumbnails.medium.url,
      publishedAt: item.snippet.publishedAt,
    }));
  } catch (error) {
    console.error("Error fetching channel videos:", error);
    return [];
  }
};

export const searchTrendingInNiche = async (
  apiKey: string,
  niche: string,
  maxResults: number = 10
): Promise<YouTubeVideo[]> => {
  try {
    const response = await fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${encodeURIComponent(niche)}&order=viewCount&type=video&maxResults=${maxResults}&key=${apiKey}`
    );
    const data = await response.json();

    if (!data.items || !apiKey || apiKey === "YOUR_GOOGLE_API_KEY") return dummyTrendingVideos;

    return data.items.map((item: any) => ({
      id: item.id.videoId,
      title: item.snippet.title,
      description: item.snippet.description,
      thumbnail: item.snippet.thumbnails.medium.url,
      publishedAt: item.snippet.publishedAt,
    }));
  } catch (error) {
    console.error("Error searching trends:", error);
    return [];
  }
};
